import {baseRequest} from './base';

//获取数据
function showStatistics(){
  let tempUrl = '/api/pcWeb/dashboard/show/showStatistics';
  return baseRequest(tempUrl,'get');
}

//学生报名量排名:取前10家学校
function studentApplyTotal(params){
  let tempUrl = '/api/pcWeb/dashboard/show/studentApplyTotal';
  return baseRequest(tempUrl,'post',params);
}

//课程方类别占比
function institutionCategory(params){
  let tempUrl = '/api/pcWeb/dashboard/show/institutionCategory';
  return baseRequest(tempUrl,'get',params);
}

//课程类别占比
function courseCategory(params){
  let tempUrl = '/api/pcWeb/dashboard/show/courseCategory';
  return baseRequest(tempUrl,'get',params);
}

export default {
  showStatistics,studentApplyTotal,institutionCategory,courseCategory
}
